import { memo, SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={props.className}
		{...props}
	>
		<g clipPath="url(#clip0_728_19059)">
			<path
				d="M5.72541 0.993701C4.22667 1.51362 2.93417 2.50046 2.03774 3.80925C1.14131 5.11804 0.688209 6.67981 0.744988 8.26514C0.801766 9.85048 1.36543 11.3758 2.35319 12.6171C3.34095 13.8585 4.70074 14.7503 6.23283 15.1617C7.47493 15.4822 8.77628 15.4962 10.025 15.2027C11.1562 14.9486 12.2021 14.4051 13.0602 13.6253C13.9532 12.789 14.6015 11.7251 14.9352 10.548C15.2979 9.26792 15.3624 7.92175 15.1238 6.61284H8.14884V9.5062H12.1883C12.1076 9.96767 11.9346 10.4081 11.6796 10.8012C11.4247 11.1942 11.0931 11.5318 10.7047 11.7937C10.2114 12.12 9.6554 12.3395 9.07228 12.4382C8.48745 12.547 7.88758 12.547 7.30275 12.4382C6.71 12.3157 6.14927 12.071 5.65627 11.7199C4.86425 11.1592 4.26956 10.3628 3.95705 9.44409C3.63925 8.50822 3.63925 7.49363 3.95705 6.55776C4.1795 5.90177 4.54724 5.30448 5.03283 4.8105C5.58852 4.23481 6.29205 3.82331 7.06621 3.62113C7.84038 3.41896 8.65528 3.43393 9.4215 3.6644C10.0201 3.84814 10.5674 4.16917 11.0199 4.6019C11.4754 4.14878 11.9301 3.69448 12.384 3.23901C12.6184 2.99409 12.8738 2.76089 13.1047 2.51011C12.414 1.86731 11.6032 1.36713 10.7188 1.03823C9.10826 0.453454 7.34608 0.437739 5.72541 0.993701Z"
				fill="#4285F4"
			/>
			<path
				d="M5.7252 0.993293C7.34574 0.436954 9.10792 0.452256 10.7186 1.03665C11.6031 1.36778 12.4135 1.87037 13.1033 2.51556C12.8689 2.76634 12.6217 3.00072 12.3826 3.24447C11.9279 3.69837 11.4736 4.15072 11.0197 4.6015C10.5672 4.16877 10.0198 3.84774 9.42129 3.664C8.65532 3.43272 7.84045 3.41688 7.06608 3.61823C6.2917 3.81957 5.58775 4.23032 5.03145 4.8054C4.54586 5.29939 4.17812 5.89667 3.95566 6.55267L1.52637 4.67181C2.39591 2.94747 3.90146 1.62848 5.7252 0.993293Z"
				fill="#EA4335"
			/>
			<path
				d="M0.881637 6.53516C1.01221 5.88804 1.22899 5.26136 1.52617 4.67188L3.95547 6.55742C3.63767 7.49329 3.63767 8.50788 3.95547 9.44375C3.14609 10.0687 2.33632 10.6969 1.52617 11.3281C0.782204 9.84725 0.555308 8.15996 0.881637 6.53516Z"
				fill="#FBBC05"
			/>
			<path
				d="M8.14896 6.61133H15.124C15.3625 7.92023 15.298 9.26641 14.9353 10.5465C14.6016 11.7236 13.9533 12.7875 13.0603 13.6238C12.2763 13.0121 11.4888 12.4051 10.7048 11.7934C11.0935 11.5312 11.4253 11.1932 11.6802 10.7998C11.9351 10.4063 12.108 9.9654 12.1884 9.50352H8.14896C8.14779 8.54023 8.14896 7.57578 8.14896 6.61133Z"
				fill="#4285F4"
			/>
			<path
				d="M1.52539 11.3277C2.33555 10.7027 3.14531 10.0746 3.95469 9.44336C4.26782 10.3623 4.86337 11.1589 5.65625 11.7191C6.15079 12.0687 6.71273 12.3113 7.30625 12.4316C7.89108 12.5404 8.49095 12.5404 9.07578 12.4316C9.6589 12.3329 10.2149 12.1134 10.7082 11.7871C11.4922 12.3988 12.2797 13.0059 13.0637 13.6176C12.2057 14.3977 11.1599 14.9417 10.0285 15.1961C8.77978 15.4897 7.47843 15.4756 6.23633 15.1551C5.25395 14.8928 4.33634 14.4304 3.54102 13.7969C2.69921 13.1285 2.01167 12.2863 1.52539 11.3277Z"
				fill="#34A853"
			/>
		</g>
		<defs>
			<clipPath id="clip0_728_19059">
				<rect
					width="15"
					height="15"
					fill="white"
					transform="translate(0.5 0.5)"
				/>
			</clipPath>
		</defs>
	</svg>
);

const GoogleIcon = memo(SvgComponent);
export { GoogleIcon };
